import React, { ForwardedRef, forwardRef } from 'react'
import { AutoCompleteProps, InputRef } from 'antd'
import cl from 'classnames'

import AutoComplete from 'Shared/atoms/AutoComplete'
import Icon from 'Shared/atoms/Icon'
import Input from 'Shared/atoms/Input'
import { withTooltip } from 'Shared/HOCs/withTooltip'
import IconButton from 'Shared/molecules/IconButton'

import styles from './styles.module.scss'

const AutoCompleteWithTooltip = withTooltip(AutoComplete)

type SearchAutocompleteProps = AutoCompleteProps & {
	placeholderText?: string
	classNameInput?: string
	showTooltip?: boolean
}

const SearchAutocomplete = forwardRef(
	(
		{
			className,
			classNameInput,
			placeholderText,
			allowClear,
			...props
		}: SearchAutocompleteProps,
		ref: ForwardedRef<InputRef | null>
	) => {
		return (
			<AutoCompleteWithTooltip
				{...props}
				value={props.value as string}
				className={cl(styles.searchAutocomplete, className)}
				popupMatchSelectWidth={false}
				tooltipText={placeholderText}
				allowClear={
					allowClear && {
						clearIcon: (
							<IconButton className={styles.closeButton} iconType="closeCircle" />
						)
					}
				}
			>
				<Input
					ref={ref}
					className={classNameInput}
					prefix={<Icon type={'search'} />}
					placeholder={placeholderText}
				/>
			</AutoCompleteWithTooltip>
		)
	}
)
export default SearchAutocomplete
